module.exports = __webpack_public_path__ + "assets/WelcomeBanner.204aaf00.svg";